import { api } from "@/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GenerateCode } from "./GenerateCode";
import "./index.scss";

// 图文验证码弹框
export const CaptchaCodeModal = (props) => {
  const {loginName, type, cancelCallBack, confirmCallBack} = props;
  const {t} = useTranslation();
  const [verCode, setVerCode] = useState("");
  const [inputVerCode, setInputVerCode] = useState("");
  const [disabled, setDisabled] = useState(false);

  // 获取验证码
  const getVerCode = async () => {
    try {
      const createRes = await api.post("/auth/verification/createTextVerCode", {
        loginName,
        type,
      });
      setVerCode(createRes.data);
    } catch (err) {
      setVerCode("");
    }
  };

  // 点击确认
  const handleClickConfirm = async () => {
    if (!inputVerCode) return;

    try {
      setDisabled(true);
      const sendCodeStatus = await confirmCallBack(inputVerCode);

      if (sendCodeStatus) {
        cancelCallBack();

        return;
      }

      // 失败后重新获取验证码
      await getVerCode();
    } catch (error) {
      console.log(error);
    } finally {
      setDisabled(false);
    }
  };

  // 初始化获取一次验证码
  useEffect(() => {
    getVerCode();
  }, []);

  return (
    <div className="captcha-code-modal">
      {/* 遮罩层 */}
      <div className="captcha-code-modal__mask"></div>
      {/* 内容区 */}
      <div className="captcha-code-modal__container">
        <div className="captcha-code-modal__container-title">{t("验证码")}</div>
        <div className="captcha-code-modal__container-content">
          <div className="captcha-code-modal__container-content-region">
            <input
              className="captcha-code-modal__container-content-region-input"
              type="text"
              autoFocus
              placeholder={t("请输入验证码")}
              onChange={(e) => setInputVerCode(e.currentTarget.value)}
              value={inputVerCode}
            />
          </div>
          <div
            className="captcha-code-modal__container-content-generate"
            onClick={getVerCode}
          >
            <GenerateCode code={verCode} />
            <div className="captcha-code-modal__container-content-generate-title">
              {t("换一张")}
            </div>
          </div>
        </div>
        <div className="captcha-code-modal__container-bottom">
          <div
            className="captcha-code-modal__container-bottom-btn cancel"
            onClick={cancelCallBack}
          >
            {t("取消")}
          </div>
          <div
            className="captcha-code-modal__container-bottom-btn confirm"
            onClick={handleClickConfirm}
            disabled={disabled}
          >
            {t("确定")}
          </div>
        </div>
      </div>
    </div>
  );
};
